import { Box, Button, Typography } from "@mui/material";
import PageLayout from "../../components/PageLayout/PageLayout";
import { styles } from "./styles";
import { useNavigate } from "react-router-dom";

const Success: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <Box sx={styles.paymentSuccessfulContainer}>
        <Box sx={styles.detailsContainer}>
          <Typography sx={{ marginTop: "20px" }} variant="h4">
            Payment Successful
          </Typography>
          <Button onClick={() => navigate("/my-tracks")} sx={styles.button}>
            Continue
          </Button>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default Success;
